var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manager_dashboard" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.checkIsManager()
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: false,
                  show_back_button: true,
                  back_link: "managerReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkIsMentor()
            ? _c("ManagerSidebarMenu", {
                attrs: {
                  show_menu: false,
                  show_back_button: true,
                  back_link: "mentorReports"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrapper",
              staticStyle: { "padding-left": "82px" }
            },
            [
              _c("div", { staticClass: "container-wrapper center ml-2" }, [
                _c("div", { staticClass: "rep_audit_bg" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 col-xl-4 pr-5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cp-filter-label col-3 float-left pr-3",
                                    staticStyle: { margin: "20px 0 0 0" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                User:"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-form-select", {
                                  staticClass: "col-9 float-left",
                                  staticStyle: {
                                    "margin-bottom": "10px !important",
                                    "margin-top": "12px"
                                  },
                                  attrs: { options: _vm.menteeLists },
                                  on: {
                                    change: function($event) {
                                      return _vm.filterCompetency()
                                    }
                                  },
                                  model: {
                                    value: _vm.rep_mentee,
                                    callback: function($$v) {
                                      _vm.rep_mentee = $$v
                                    },
                                    expression: "rep_mentee"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12 col-xl-5 px-0" }, [
                              _c(
                                "div",
                                { staticClass: "col-7 p-0 float-left" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cp-filter-label col-5 float-left",
                                      staticStyle: {
                                        width: "37%",
                                        "margin-top": "20px"
                                      }
                                    },
                                    [_vm._v("Date Range:")]
                                  ),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass: "col-7 float-left",
                                    staticStyle: {
                                      "margin-bottom": "10px !important",
                                      "margin-top": "12px"
                                    },
                                    attrs: { options: _vm.itemSource2 },
                                    on: {
                                      change: function($event) {
                                        return _vm.filterCompetency()
                                      }
                                    },
                                    model: {
                                      value: _vm.rep_days,
                                      callback: function($$v) {
                                        _vm.rep_days = $$v
                                      },
                                      expression: "rep_days"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-5 p-0 float-left pl-4",
                                  staticStyle: {
                                    "margin-top": "15px",
                                    "padding-bottom": "10px !important"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-2 float-left p-0 custom-checkbox"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.show_comments,
                                            expression: "show_comments"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        staticStyle: {
                                          "margin-top": "5px",
                                          "margin-left": "1px"
                                        },
                                        attrs: {
                                          name: "show_comments",
                                          value: "1",
                                          id: "show_comments_checkbox",
                                          type: "checkbox"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.show_comments
                                          )
                                            ? _vm._i(_vm.show_comments, "1") >
                                              -1
                                            : _vm.show_comments
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changeShowComments(
                                              $event
                                            )
                                          },
                                          change: function($event) {
                                            var $$a = _vm.show_comments,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "1",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.show_comments = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.show_comments = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.show_comments = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass: "custom-control-label",
                                        staticStyle: {
                                          "margin-left": "30px",
                                          "margin-top": "5px"
                                        },
                                        attrs: { for: "show_comments_checkbox" }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-10 float-left p-0 pl-2 bold",
                                      staticStyle: { "margin-top": "5px" }
                                    },
                                    [
                                      _vm._v(
                                        "Show Comments\n                                                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "col-12 col-xl-3",
                                staticStyle: {
                                  float: "right",
                                  "text-align": "right",
                                  "margin-top": "12px"
                                }
                              },
                              [
                                _vm.results.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          float: "right",
                                          "margin-left": "15px"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.shareButtonModal()
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            src: require("@/assets/Send_Report_Button.svg"),
                                            alt: "MentorMentee",
                                            width: "24px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.results.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "margin-left": "15px",
                                          "margin-top": "2px",
                                          float: "right",
                                          "margin-right": "0px"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.exportCSVAction()
                                          }
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            src: require("@/assets/Download_Report.svg"),
                                            alt: "MentorMentee",
                                            width: "24px"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info btn-md",
                                    staticStyle: {
                                      float: "left",
                                      "border-radius": "10px",
                                      "margin-left": "30px"
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.filterCompetency()
                                      }
                                    }
                                  },
                                  [_vm._v("Filter")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } }),
                _vm._v(" "),
                _c("div", { staticClass: "rep_audit_bg pt-0" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm.show_comments == true
                    ? _c("div", { staticClass: "row report_heading px-3" }, [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "7%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("submitted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Submitted\n                            "
                            ),
                            _vm.sortField == "submitted" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "submitted" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "13%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("description")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task\n                            "
                                ),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "13%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("description")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task\n                            "
                                ),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "10%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("tasklist_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task List\n                            "
                                ),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("tasklist_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task List\n                            "
                                ),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentee_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.menteeTitle) +
                                    "\n                            "
                                ),
                                _vm.sortField == "mentee_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentee_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "6%" } }, [
                          _vm._v(
                            "\n                            # of Reps\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "10%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentor_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Approved by\n                            "
                                ),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "16%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentor_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Approved by\n                            "
                                ),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "13%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("timeOnTask")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Time\n                            "
                                ),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("timeOnTask")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Time\n                            "
                                ),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { width: "8%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("score")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Rating\n                            "
                            ),
                            _vm.sortField == "score" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "score" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { width: "7%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("createdAt")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Approved\n                            "
                            ),
                            _vm.sortField == "createdAt" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "createdAt" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.show_comments == true
                          ? _c("div", { staticStyle: { width: "10%" } }, [
                              _vm._v(
                                "\n                            Comments\n                        "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(2)
                      ])
                    : _c("div", { staticClass: "row report_heading px-3" }, [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "7%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("submitted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Submitted\n                            "
                            ),
                            _vm.sortField == "submitted" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "submitted" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "16%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("description")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task\n                            "
                                ),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "16%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("description")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task\n                            "
                                ),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "description" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "10%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("tasklist_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task List\n                            "
                                ),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("tasklist_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Task List\n                            "
                                ),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "tasklist_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentee_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.menteeTitle) +
                                    "\n                            "
                                ),
                                _vm.sortField == "mentee_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentee_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "6%" } }, [
                          _vm._v(
                            "\n                            # of Reps\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "10%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentor_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Approved by\n                            "
                                ),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "16%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("mentor_name")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Approved by\n                            "
                                ),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "mentor_name" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        !_vm.rep_mentee
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "13%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("timeOnTask")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Time\n                            "
                                ),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "15%",
                                  cursor: "pointer"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.sortMethod("timeOnTask")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                            Time\n                            "
                                ),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "ASC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-asc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.sortField == "timeOnTask" &&
                                _vm.sortBy == "DESC"
                                  ? _c("i", {
                                      staticClass: "fa fa-sort-desc",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  : _vm._e()
                              ]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { width: "10%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("score")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Rating\n                            "
                            ),
                            _vm.sortField == "score" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "score" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: { width: "10%", cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.sortMethod("createdAt")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Approved\n                            "
                            ),
                            _vm.sortField == "createdAt" && _vm.sortBy == "ASC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-asc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sortField == "createdAt" && _vm.sortBy == "DESC"
                              ? _c("i", {
                                  staticClass: "fa fa-sort-desc",
                                  attrs: { "aria-hidden": "true" }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm._m(3)
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "loading_show"
                    },
                    [_c("div", { staticClass: "spinner-border text-danger" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _vm.results.length > 0
                      ? _c("div", { staticClass: "col-12 p-0 px-3" }, [
                          _c("div", { staticClass: "view-accountlist" }, [
                            _vm.show_comments == true
                              ? _c(
                                  "div",
                                  _vm._l(_vm.results, function(result, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "row report_view px-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { width: "7%" } },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(result.submittedDate) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "13%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.description)
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "13%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.description)
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "10%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.tasklist_name)
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "15%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.tasklist_name)
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "15%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentee_name) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: " txt_break",
                                            staticStyle: { width: "6%" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(result.RepCounts) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "10%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentor_name) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "16%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentor_name) +
                                                    "."
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              { staticStyle: { width: "13%" } },
                                              [
                                                _vm._v(
                                                  _vm._s(result.timeOnTask) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticStyle: { width: "15%" } },
                                              [
                                                _vm._v(
                                                  _vm._s(result.timeOnTask) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        result.score != 0
                                          ? _c(
                                              "div",
                                              { staticStyle: { width: "8%" } },
                                              [_vm._v(_vm._s(result.score))]
                                            )
                                          : _c("div", {
                                              staticStyle: { width: "8%" }
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { width: "7%" } },
                                          [_vm._v(_vm._s(result.updatedDate))]
                                        ),
                                        _vm._v(" "),
                                        _vm.show_comments == true &&
                                        result.score != "Skill Pass"
                                          ? _c(
                                              "div",
                                              { staticStyle: { width: "10%" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(result.mentee_name) +
                                                      ".-"
                                                  )
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(result.menteeComment)
                                                ),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(result.mentor_name) +
                                                      ".-"
                                                  )
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(result.comment) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticStyle: { width: "10%" } },
                                              [
                                                _vm._v(
                                                  "\n                                             \n                                        "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _vm._m(4, true)
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c(
                                  "div",
                                  _vm._l(_vm.results, function(result, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "row report_view px-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticStyle: { width: "7%" } },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(result.submittedDate) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "16%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.description)
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "16%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.description)
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "10%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.tasklist_name)
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "15%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.tasklist_name)
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "15%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentee_name) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: " txt_break",
                                            staticStyle: { width: "6%" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(result.RepCounts) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "10%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentor_name) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: " txt_break",
                                                staticStyle: { width: "16%" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(result.mentor_name) +
                                                    "."
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        !_vm.rep_mentee
                                          ? _c(
                                              "div",
                                              { staticStyle: { width: "13%" } },
                                              [
                                                _vm._v(
                                                  _vm._s(result.timeOnTask) +
                                                    "."
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticStyle: { width: "15%" } },
                                              [
                                                _vm._v(
                                                  _vm._s(result.timeOnTask) +
                                                    "\n                                        "
                                                )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        result.score != 0
                                          ? _c(
                                              "div",
                                              { staticStyle: { width: "10%" } },
                                              [_vm._v(_vm._s(result.score))]
                                            )
                                          : _c("div", {
                                              staticStyle: { width: "10%" }
                                            }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { width: "10%" } },
                                          [_vm._v(_vm._s(result.updatedDate))]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(5, true)
                                      ]
                                    )
                                  }),
                                  0
                                )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 float-left override-padding pagination-wrapper"
                            },
                            [
                              _c("Pagination", {
                                ref: "Pagination",
                                attrs: {
                                  currentPage: _vm.currentPage,
                                  totalRows: _vm.rows,
                                  perPage: _vm.perPage,
                                  showPaginatedFunction:
                                    _vm.showNaicsofPaginated,
                                  showPerPageFunction: _vm.perPagePaginated,
                                  totalPages: _vm.totalPages,
                                  sNo: _vm.sno
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm.loading == false
                      ? _c(
                          "div",
                          {
                            staticClass: "col-12 p-0 px-3",
                            staticStyle: { "text-align": "center" }
                          },
                          [
                            _vm._v(
                              "\n                            No records found.\n                        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BatchModal",
        {
          attrs: { isModalVisible: _vm.isExportModalVisible },
          on: {
            close: function($event) {
              _vm.isExportModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n            Loading...\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "sub-heading",
            attrs: { slot: "header" },
            slot: "header"
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", {}, [
              _c("div", { staticClass: "export-details" }, [
                _vm._v(
                  "\n                    Exported: " +
                    _vm._s(_vm.rowsExportedCSV) +
                    " of " +
                    _vm._s(_vm.rowsCSV) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "percentage-text" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.percentage) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "batch-box" }, [
                _c(
                  "div",
                  {
                    staticClass: "batch-loading",
                    attrs: { id: "batch-loading" }
                  },
                  [_vm._v("\n                         \n                    ")]
                )
              ]),
              _vm._v(" "),
              _vm.percentage == "100%"
                ? _c(
                    "div",
                    {
                      staticClass: "download-link",
                      on: {
                        click: function($event) {
                          return _vm.downloadFunc()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Download CSV File\n                "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "ShareReportModal",
        {
          attrs: { isModalVisible: _vm.isModalVisible },
          on: {
            close: function($event) {
              ;(_vm.isModalVisible = false), (_vm.share_email = "")
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n            Loading...\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Share Report")])]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _vm.showShareSuccess == true
              ? _c(
                  "div",
                  {
                    staticClass: "col-12 override-padding",
                    staticStyle: {
                      color: "#68C47E",
                      "text-align": "center",
                      "margin-bottom": "15px"
                    }
                  },
                  [_c("b", [_vm._v("Report shared successfully!")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 override-padding" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.share_email,
                    expression: "share_email"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "col-lg-12 input-text form-control",
                staticStyle: { "line-height": "30px" },
                attrs: {
                  name: "share_email",
                  placeholder: "Enter Email...",
                  "data-vv-as": "Email address",
                  maxlength: "255"
                },
                domProps: { value: _vm.share_email },
                on: {
                  keyup: function($event) {
                    return _vm.checkEmail()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.share_email = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.verrors.has("share_email"),
                      expression: "verrors.has('share_email')"
                    }
                  ],
                  staticClass: "validate-warning-msg"
                },
                [
                  _vm._v(
                    _vm._s(_vm.verrors.first("share_email")) +
                      "\n                "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "margin-bottom-10",
              staticStyle: { clear: "both" }
            }),
            _vm._v(" "),
            _vm.showWait == false
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-red col-3 input-height-25 createBtn",
                        staticStyle: {
                          "line-height": "30px",
                          "border-radius": "10px"
                        },
                        attrs: { disabled: _vm.share_button_disable },
                        on: {
                          click: function($event) {
                            return _vm.shareButtonSubmit()
                          }
                        }
                      },
                      [_c("b", [_vm._v(_vm._s(_vm.submit_text))])]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showWait == true
              ? _c(
                  "div",
                  { staticClass: "col-12 override-padding text-align-right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-dard-grey col-lg-3",
                        staticStyle: {
                          "line-height": "30px",
                          "border-radius": "10px"
                        },
                        attrs: { disabled: "true" }
                      },
                      [_c("b", [_vm._v("Please wait...")])]
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      this.isManager == true
        ? _c("RepsAuditStatsModal", {
            ref: "rep_audit_stats",
            attrs: { isModalVisible: _vm.isRepAuditStatsModalVisible },
            on: {
              close: function($event) {
                _vm.isRepAuditStatsModalVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "h3",
          { staticClass: "rep_heading pb-1 border-bottom text-uppercase" },
          [_vm._v("Competency Audit Trail")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row d-none" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h3", { staticClass: "rep_heading pb-1 border-bottom" }, [
          _vm._v("Repp Audit Trail")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 padding-lr-5" }, [
      _c("div", { staticClass: "custom_heading_hr" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 padding-lr-5" }, [
      _c("div", { staticClass: "custom_heading_hr" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 padding-lr-5" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 padding-lr-5" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-006f54f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-006f54f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/competency_audit_trail.vue
// module id = null
// module chunks = 